const problemReportsActions = {
  REQUEST_REPORTS: "REQUEST_REPORTS",
  RECIEVE_REPORTS: "RECIEVE_REPORTS",
  SERVER_ERROR_OCURED: 'SERVER_ERROR_OCURED',
  CLEAR_ERRORS: 'CLEAR_ERRORS',
}

export default problemReportsActions;


// WEBPACK FOOTER //
// src/routes/ProblemReports/actions/actionTypes.js